/* import __COLOCATED_TEMPLATE__ from './max-temperature-range.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();